export default __webpack_public_path__ + "static/media/qr-apple.3a7a38cd.svg";